import { render, staticRenderFns } from "./FinancialstatementPreparation.vue?vue&type=template&id=25de969b&scoped=true"
import script from "./FinancialstatementPreparation.vue?vue&type=script&lang=js"
export * from "./FinancialstatementPreparation.vue?vue&type=script&lang=js"
import style0 from "./FinancialstatementPreparation.vue?vue&type=style&index=0&id=25de969b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de969b",
  null
  
)

export default component.exports